import { useEffect, useState } from "react";
import Image from 'react-bootstrap/Image';
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';
import Spinner from 'react-bootstrap/Spinner';
import { s3Link } from '../../utils/constants';
import './style.scss';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useToasts } from 'react-toast-notifications';

import DefaultVideoThumb from '../../images/video_thumb.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PVideo from "../PVideo";
import { connect } from 'react-redux';

const PMediaExisting = ({
    file,
    index,
    remove,
    isDragging = false,
    updateThumbnailHandler,
    height = 80,
    width = 80,
    removable = true,
    videoOptions = {},
    changeableCoverPic = true,
    playable = true,
    activePost
}) => {
    const { addToast } = useToasts();

    const [fileType, setFiletype] = useState('');
    const [extension, setExtension] = useState('');
    const [src, setSrc] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [thumbnails, setThumbnails] = useState([]);
    const [activeThumb, setActiveThumb] = useState({});

    useEffect(() => {
        if (file.type) {
            const extension = file.file_path.split('.');
            setExtension(extension[extension.length - 1].toUpperCase());
            setFiletype(file.type.toUpperCase());
        }

        setSrc(`${s3Link}/${file.thumb_path}`);
    }, [file]);

    const handleRemove = (e) => {
        e.preventDefault();
        remove(file);
    };

    const handleSelectThumbnail = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsGenerating(true);
        await axios.get('/api/thumbnails', {
            params: {
                media_id: file.media_id
            }
        })
            .then(response => {
                setThumbnails(response.data);
                setShowModal(true);
            })
            .catch(error => {
                console.log({ error });
            })
            .finally(() => {
                setIsGenerating(false);
            });
    };

    const handleThumbnailSelection = (e, thumb) => {
        e.stopPropagation();
        setActiveThumb(thumb);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        await axios.patch(`/api/medias/${file.media_id}`, {
            thumb_path: activeThumb.file_path,
            large_path: activeThumb.file_path
        })
            .then(response => {
                updateThumbnailHandler(file, activeThumb);
                setShowModal(false);
                setSrc(s3Link + '/' + activeThumb.file_path);
                addToast('Thumbnail successfully updated', { appearance: 'success', autoDismiss: true });
            })
            .catch(error => {
                console.log({ error });
                addToast('Sorry! Unable to update thumbnail', { appearance: 'error', autoDismiss: true });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return <div className="media" style={{ width: `${width}px`, height: `${height}px` }}>
        {
            removable && ((Object.keys(activePost).length <= 0) || activePost.price === null) && <i className="media__remove d-none d-md-block" onClick={(e) => handleRemove(e)} />
        }

        <span className="media__type">{extension}</span>
        {
            fileType === 'VIDEO' && changeableCoverPic && <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="button-tooltip-2">Select the image to show as the cover for your video</Tooltip>}
            >
                <span className={`media__action${isGenerating ? ' avoid-clicks' : ''}`} onClick={handleSelectThumbnail} style={{ zIndex: 999 }}>
                    {!isGenerating ? 'Cover Pic' : <Spinner variant="light" animation="border" size="sm" />}
                </span>
            </OverlayTrigger>
        }

        {
            fileType === 'VIDEO' && playable
                ? <PVideo
                    thumb={`${s3Link}/${file.thumb_path}`}
                    video={`${s3Link}/${file.file_path}`}
                    autoplay={true}
                    videoOptions={videoOptions}
                />
                : <Image src={src} style={{ width: `${width}px`, height: `${height}px`, objectFit: 'cover' }} fluid />
        }

        {
            fileType === 'VIDEO' && <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showModal}
                onHide={() => setShowModal(false)}
                onClick={(e) => e.stopPropagation()}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter" style={{ lineHeight: 1 }}>
                        Select cover pic
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: 'auto' }}>
                    <Row>
                        {
                            thumbnails && thumbnails.map((thumb, index) => (
                                <Col md={4} className="thumbnails my-1" key={index}>
                                    <div className="thumbnails__thumbnail" onClick={(e) => handleThumbnailSelection(e, thumb)}>
                                        {Object.keys(activeThumb).length > 0 && activeThumb.id === thumb.id && <span className="thumbnails__active">
                                            <FontAwesomeIcon icon={['far', 'check-circle']} />
                                        </span>
                                        }
                                        <Image src={`${s3Link}/${thumb.file_path}`} fluid rounded />
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={() => setShowModal(false)}>Close</Button>
                    <Button disabled={isLoading} variant="primary" onClick={handleSave}>
                        {!isLoading ? 'Save' : 'Saving...'}
                    </Button>
                </Modal.Footer>
            </Modal>
        }
    </div>;
};

const mapStateToProps = state => {
    return {
        activePost: state.post.selectedPost
    };
};

export default connect(mapStateToProps)(PMediaExisting);
